import ElinorForward from './ElinorForward';

export default class OverlayElinorTalk extends Phaser.Group {
  constructor(game, textIds, delay = 0) {
    super(game);

    this.onClose = new Phaser.Signal();

    //
    this.bg = this.game.make.image(0, 0, 'bg_location_' + this.game.controller.location);
    this.addChild(this.bg);

    // lock content under
    this.bg.inputEnabled = true;

    //
    this.elinor = new ElinorForward(this.game);
    this.elinor.x = this.game.defaultWidth * 0.5;
    this.elinor.y = this.game.defaultHeight;
    this.elinor.setScale(2);
    this.elinor.idle();
    this.addChild(this.elinor);

    //
    this.textInd = -1;
    this.textIds = textIds;
    this.cptData = this.game.cache.getJSON('vo_ui_captions');
    this.game.springRollCaptionsPlugin.setData(this.cptData);

    //
    this.game.time.events.add(delay, this.playText, this);
  }

  playText() {
    this.textInd++;
    if (this.textInd < this.textIds.length) {
      const textId = this.textIds[this.textInd];
      const data = this.cptData[textId];
      const talkTime = data[data.length - 1].end;
      this.game.springRollCaptionsPlugin.playCaption(textId);
      this.game.sounds.playVO(textId, { spriteID: 'vo_ui' });

      //
      this.elinor.talk();
      this.game.time.events.add(talkTime, this.playText, this);
    } else {
      this.elinor.idle();
      this.game.time.events.add(1000, this.handleInputDown, this);
    }
  }

  handleInputDown() {
    this.onClose.dispatch();
  }

  destroy() {
    this.elinor.destroy();
    this.elinor = null;
    super.destroy();
  }
}
